import React, { useState, useEffect } from "react";
import { Box, IconButton, Typography, Paper } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface LanguageOption {
  name: string;
  code: string;
}

const LanguagePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>("");

  // Available languages
  const languages: LanguageOption[] = [
    { name: "English", code: "en" },
    { name: "Japanese", code: "ja" },
  ];

  // Initialize selected language based on current i18n setting
  useEffect(() => {
    const currentLang =
      localStorage.getItem("language") || i18n.language || "en";
    setSelectedLanguage(currentLang);
  }, [i18n.language]);

  // Handle language selection
  const handleLanguageSelect = (langCode: string) => {
    setSelectedLanguage(langCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem("language", langCode);
  };

  return (
    <Box className="flex flex-col bg-white h-[75vh] md:h-[80vh] ">
      <Box className="flex-1 pt-2 mx-auto w-full sm:max-w-md md:max-w-xl lg:max-w-2xl xl:max-w-4xl shadow-lg rounded-2xl">
        <Box className="p-2 flex items-center ">
          <IconButton
            onClick={() => navigate("/profile")}
            className="mr-4"
            size="medium"
          >
            <ArrowLeft size={24} />
          </IconButton>
          <div className="ml-2">
            <Typography variant="h6" className="font-semibold ">
              {t("title.language")}
            </Typography>
          </div>
        </Box>

        {/* Language options */}
        <Box className="p-4 ml-2">
          <Paper elevation={0} className="w-full">
            {languages.map((language) => (
              <div
                key={language.code}
                className="flex items-center py-3 px-2"
                onClick={() => handleLanguageSelect(language.code)}
              >
                <div
                  className={`w-5 h-5 rounded-full border flex items-center justify-center mr-4 
                ${selectedLanguage === language.code ? "border-orange-500" : "border-gray-300"}`}
                >
                  {selectedLanguage === language.code && (
                    <div className="w-3 h-3 rounded-full bg-orange-500"></div>
                  )}
                </div>
                <Typography variant="body1">{language.name}</Typography>
              </div>
            ))}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default LanguagePage;
